export default __webpack_public_path__ + "assets/ogg/e5f2c6f0877304839fead0764dfb3fbc.ogg";